export enum ContentSourceType {
  NATIVE = "native",
  INTEGRATION = "integration",
  DRAFT = "draft",
}
